import * as React from 'react';
import { RadioSymbol, Textarea } from 'ui';
import { FilterCommonProps, OptionType, SubOptionType } from './types';
import { getValue } from './get-value';
import { MeatballPanel } from 'app/area/search-filters/filters/meatball-panel';
import styles from './filter-text-specified.scss';

export class FilterTextSpecified extends React.PureComponent<FilterCommonProps<string>> {

  private onChange = (e: React.SyntheticEvent<any>) => {
    const optionType = e.currentTarget.value;
    const notSpecified = optionType === OptionType.notSpecified;

    this.props.onChange(this.props.id, [{
      optionType,
      value: notSpecified ? {} as any : undefined
    }]);
  };

  private onChangeText = (value: string, subOptionType: SubOptionType) => {
    const { values } = this.props;

    this.props.onChange(this.props.id, [{
      optionType: OptionType.specified,
      subOptionType: SubOptionType.text,
      value: subOptionType === SubOptionType.text ? value : getValue(values, SubOptionType.text).value
    }].filter(v => !!v.value) || []);
  };

  private onChangeSpecifiedText = (value: string) => this.onChangeText(value, SubOptionType.text);

  private renderSpecifiedText = () => {
    const { id, values, translation } = this.props;

    const selected = !values || (values && values.some(v => v.optionType === OptionType.specified));

    const text = getValue(values, SubOptionType.text);

    return <div className="form-check">
      <input
        type="radio"
        id={`${id}_specified-text`}
        name={`${id}_text-option-type`}
        className="form-check-input visuallyhidden"
        value={OptionType.specified}
        checked={!!selected}
        onChange={this.onChange} />
      <label
        htmlFor={`${id}_specified-text`}
        className="form-check-label">
        <RadioSymbol />
        <b>{translation.filters_contains_word}</b>
      </label>

      {selected && <div className={styles.textGroup}>
        <div>
          <Textarea
            className={undefined}
            componentId={id}
            value={text.value}
            onChange={this.onChangeSpecifiedText}
            maxLength={254}
            wait={0} />
        </div>
      </div>}
    </div>;
  };

  private renderNotSpecified = () => {
    const { id, values, translation } = this.props;
    const selected = values && values.some(v => v.optionType === OptionType.notSpecified);

    return <div className="form-check">
      <input
        type="radio"
        id={`${id}_not-specified-text`}
        name={`${id}_text-option-type`}
        className="form-check-input visuallyhidden"
        value={OptionType.notSpecified}
        checked={!!selected}
        onChange={this.onChange} />
      <label
        htmlFor={`${id}_not-specified-text`}
        className="form-check-label">
        <RadioSymbol />
        <div>
          <b>{translation.filters_not_specified_title}</b>
          <p className={styles.notSpecifiedSubtitle}>{translation.filters_not_specified_subtitle}</p>
        </div>
      </label>
    </div>;
  };

  public render() {
    return <>
      <MeatballPanel configuration={this.props.meatballPanelConfiguration} />
      {this.renderSpecifiedText()}
      {this.renderNotSpecified()}
    </>;
  }
}
